// @flow
import React from 'react';

import { COLORS } from 'Components/utils/color/colors';

import { Notification } from 'Components/frameworks/notification/Notification.jsx';
import { TextLink } from 'Components/frameworks/text-link/TextLink.jsx';

type Props = {
  linkLabel: string,
  linkUrl: string,
  message?: string,
};

export function CrisisAlert(props: Props) {
  const { linkLabel, linkUrl, message } = props;

  if (!message) {
    return null;
  }

  return (
    <Notification color={COLORS.WARNING} hasBorder text={message}>
      <TextLink className="uppercase" label={linkLabel} url={linkUrl} />
    </Notification>
  );
}
